export function convertToShortGuid(deviceId) {
  const firstLetter = deviceId.substr(0, 2).toUpperCase();
  const lastLetter = deviceId.substr(deviceId.length - 4, deviceId.length).toUpperCase();

  return `${firstLetter}-${lastLetter}`;
}

export const checkFormatShortGuid = (code) => {
  const regex = /^([0-F]{2,2})-([0-F]{4,4})$/i;
  return regex.test(code);
};

export const validateTransformationRation = (value) => {
  const regex = /^\d{1,}\/\d{1,}$/i;
  return regex.test(value);
};

export const validateRatedVoltage = (value) => {
  return value > 0 && value.toString().charAt(0) != 0;
};

export const validateСosinePhi = (value) => {
  const regex = /^\d{1}(\.\d{1,})?$/i;
  return regex.test(value) && 1 >= value && value > 0;
};
